import script from "./GalleryView.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryView.vue?vue&type=script&setup=true&lang=js"

import "./GalleryView.vue?vue&type=style&index=0&id=5d9f12c3&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9f12c3"]])

export default __exports__